import { ChangeEvent, FormEvent, useState } from 'react'

import ReportGmailerrorred from '@mui/icons-material/ReportGmailerrorred'
import { Alert, Stack } from '@mui/material'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import TextField from '@mui/material/TextField'
import { streamingRestApi } from '@/service/streamingApi'
import { notifyError } from '@/utils/notifyError'

import { LoginStepProps } from '../types'
import { DGEStepData } from './types'

export const DGEEmailStepStrategy = ({ onNext, stepData }: LoginStepProps<DGEStepData>) => {
  const [email, setEmail] = useState<string>(stepData?.email ?? '')
  const [error, setError] = useState<Error>()
  const [isLoading, setIsLoading] = useState(false)

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!email) return

    setError(undefined)
    setIsLoading(true)

    try {
      const { data } = await streamingRestApi.endpoints.authorize.getLoginMethod(email)
      onNext({ email, authMethod: data.method })
    } catch (e) {
      if (e instanceof Error) {
        const message = e.message || 'Failed to verify email. Please try again.'
        setError(new Error(message))
        notifyError(message)
      } else {
        const errorMessage = 'An unexpected error occurred. Please try again.'
        setError(new Error(errorMessage))
        notifyError(errorMessage)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={onSubmit}>
      <Stack
        sx={{
          '& .MuiFormControl-root': {
            backgroundColor: '#f2f2f2'
          }
        }}
      >
        {error && (
          <Alert variant={'outlined'} color={'error'} sx={{ mb: 3 }} icon={<ReportGmailerrorred />}>
            {error.message}
          </Alert>
        )}
        <TextField
          required
          type={'email'}
          value={email}
          onChange={onEmailChange}
          label={'Email address'}
          fullWidth
          autoFocus
        />
        <Button
          type={'submit'}
          variant={'contained'}
          color={'primary'}
          sx={{ mt: 4 }}
          disabled={isLoading || !email}
          startIcon={isLoading && <CircularProgress size={24} />}
        >
          Next
        </Button>
      </Stack>
    </form>
  )
}
